import { create } from "zustand";
import { Popup, question } from "../../Types";

type viewerPopupStoreType = {
  isOpen: boolean;
  currentPopupContent?: Popup | question;
  setPopup: (pop?: Popup) => void;
  setQuestion: (question?: question) => void;
  id?: string | number;
  setOpen: (id: string | number) => void;
  setClose: () => void;

  innerPopJSX?: JSX.Element;
  setInnerJSX: (jsx?: JSX.Element) => void;
};

export const useViewerPopupStore = create<viewerPopupStoreType>()((set) => ({
  isOpen: false,
  setOpen: (id: string | number) => {
    set({ isOpen: true, id: id });
  },
  setClose: () => {
    set({ id: undefined, isOpen: false, currentPopupContent: undefined });
  },
  setPopup: (pop?: Popup) => set({ currentPopupContent: pop }),

  setQuestion: (question?: question) => set({ currentPopupContent: question }),

  setInnerJSX: (jsx?: JSX.Element) => {
    if (jsx) set({ innerPopJSX: jsx });
    else set({ innerPopJSX: undefined });
  },
}));


type viewerMapStoreType = {
  isOpen: boolean;
  id?: number;

  setOpen: (id: number) => void;
  setClosed: () => void;
};

export const useViewerMapStore = create<viewerMapStoreType>((set, get) => ({
  isOpen: false,
  setOpen: (id: number) => {
    const alreadyOpen = get().isOpen;

    if (alreadyOpen) set({ isOpen: false, id: undefined });
    else set({ isOpen: true, id: id });
  },
  setClosed: () => {
    set({ isOpen: false, id: undefined });
  },
}));
